import { render } from "./unauthorized.vue?vue&type=template&id=86f7cd7a"
import script from "./unauthorized.vue?vue&type=script&lang=ts"
export * from "./unauthorized.vue?vue&type=script&lang=ts"

import "./unauthorized.vue?vue&type=style&index=0&id=86f7cd7a&lang=scss"
script.render = render

export default script